module.exports = "/_next/static/images/impact-43c5ac650d1afc6c125277ce7e4efc82.jpg";